import React, { ReactNode } from 'react';

const CustomTooltip = ({
  text,
  children,
}: {
  text: ReactNode;
  children: ReactNode;
}) => {
  return (
    <div className='tooltip'>
      {children}
      <span className='tooltiptext'>{text}</span>
    </div>
  );
};

export default CustomTooltip;
